const CompanyAccountType = {
    FREE: 1,
    TRIAL: 2,
    SUBSCRIPTION: 3
};

export default CompanyAccountType;